import React, { useRef } from "react";
import PropTypes from "prop-types";
import useRouteManager from "src/utils/customHook/useRouteManager";
import { useEffect, useState } from "react";
import { readDefaultBroker } from "src/utils/utils";
import { useHistory } from "react-router";
import { COOKIES } from "src/context/constants";
import useCookie from "src/hooks/useCookie";
import authService from "src/services/authService";

import { MOCK_SECRET_PATH } from "src/config";
import InvalidBrokerPage from "./InvalidBrokerPage";

import { setTimeout } from "timers";
import LoadingWithPlaintLayoutScreen from "../LoadingWithPlainLayoutScreen";
import MaintenancePage from "src/views/MaintenancePage";

interface authProps {
  children: any;
}

const NO_BROKER_URL = ["stt", MOCK_SECRET_PATH];
const PUBLIC_PATH_SHORTCUT = ["explore", "model"];

const MultiBrokerManager: React.FC<authProps> = ({ children }) => {
  const history = useHistory();
  const loadingRef = useRef(true);
  const [loading, setLoading] = useState(true);
  const [brokerAllInvalid, setBrokerAllInvalid] = useState(false);
  const [isTimeout, setIsTimeout] = useState(false);
  // const [isTimeout,setIsTimeout] = useState(false)
  const { getCookie } = useCookie();
  const { saveBroker, brokerNameOnURL, mapperBrokernameToBroker } =
    useRouteManager();

  useEffect(() => {
    setTimeout(() => {
      if (loadingRef.current) {
        setIsTimeout(true);
      }
    }, 10000);
  }, []);

  const handleChangeLoading = (val: boolean) => {
    setLoading(val);
    loadingRef.current = val;
  };

  const toBroker = (broker: string) => {
    let path = window.location.pathname;
    let path_l = path.split("/");
    path_l[1] = broker;
    let newPath = path_l.join("/");
    // let newPath = `/${broker}/`

    history.replace(newPath);
  };

  const switchBroker = async (fromBrokerName: string, toBrokerName: string) => {
    const fromBrokerID =
      mapperBrokernameToBroker[fromBrokerName.toLowerCase()]?.brokerID;
    const toBrokerID =
      mapperBrokernameToBroker[toBrokerName.toLowerCase()]?.brokerID;
    const res = await authService.switchBroker(fromBrokerID, toBrokerID);
    //reload only if change success
    // if (data.__typename === "SwitchBroker" && data.success) return window.location.reload()
    // if (data.__typename === "SwitchBroker" && data.success) return setLoading(false)

    handleChangeLoading(false);
  };

  //read broker from url ...
  useEffect(() => {
    const search = history.location.search;
    if (Object.keys(mapperBrokernameToBroker).length > 0) {
      const latestBroker = getCookie(COOKIES.latestSelBroker) || "";
      let defaultBroker = readDefaultBroker() || "";

      const isCorrectBroker = !!mapperBrokernameToBroker[brokerNameOnURL];
      const isCorrectLatestBroker = !!mapperBrokernameToBroker[latestBroker];

      if (typeof defaultBroker === "string")
        defaultBroker = defaultBroker.toLowerCase();

      const isCorrectDefaultBroker = !!mapperBrokernameToBroker[defaultBroker];

      //preserved word ...
      if (brokerNameOnURL === "404") {
        history.push("/404");
        handleChangeLoading(false);
      } else if (NO_BROKER_URL.includes(brokerNameOnURL)) {
        handleChangeLoading(false);
      } else if (PUBLIC_PATH_SHORTCUT.includes(brokerNameOnURL)) {
        history.replace(
          `${
            latestBroker || defaultBroker || "ENV_MB245"
          }/${brokerNameOnURL}${search}`
        );
        handleChangeLoading(false);
      } else if (isCorrectBroker) {
        saveBroker(brokerNameOnURL);

        //if latest broker and current broker not match then switch access token ...
        if (brokerNameOnURL !== latestBroker) {
          switchBroker(latestBroker, brokerNameOnURL);
          history.replace("portfolio");
        }

        //if both are matched then load child components ...
        else handleChangeLoading(false);
      }
      //if brokor invalid (not any in mapper) then swtich to latest broker ...
      else if (isCorrectLatestBroker) {
        saveBroker(latestBroker);
        toBroker(latestBroker);
        handleChangeLoading(false);
      }
      //if latest broker still invalid then use default broker from ENV ...
      else if (isCorrectDefaultBroker) {
        saveBroker(defaultBroker);
        toBroker(defaultBroker);
        handleChangeLoading(false);
      }
      //if cant find env then error code ...
      else {
        // toBroker("ENV_MB245")
        handleChangeLoading(false);
        setBrokerAllInvalid(true);
      }
    }
    // eslint-disable-next-line
  }, [mapperBrokernameToBroker, brokerNameOnURL]);

  if (isTimeout) return <MaintenancePage />;
  if (brokerAllInvalid) return <InvalidBrokerPage />;
  if (loading) return <LoadingWithPlaintLayoutScreen />;

  return children;
};

MultiBrokerManager.propTypes = {
  children: PropTypes.any,
};

export default MultiBrokerManager;
